import { useNavigate } from "react-router-dom"
import Button from "../Components/Button"
import PageHeader from "../Components/PageHeader"
import { LogoutButton } from "../Components/LogoutButton"

const NoPlans = () => {
  const navigate = useNavigate()

  return (
    <div className="flex min-h-screen flex-col bg-background">
      <PageHeader logo={"/logo.png"} rightComponent={<LogoutButton />} />
      <div className="mx-auto w-full max-w-5xl p-12">

        <div className="flex flex-col items-center justify-center text-center">
          <div className="mb-8">
            <h1 className="mb-4 text-3xl font-bold text-brand">No Plans Yet</h1>
            <p className="text-lg text-gray-600">
              You don't have any plans yet. Create your first plan to begin your journey.
            </p>
          </div>

          <div className="flex gap-4">
            <Button onClick={() => navigate("/plan/new")}>
              Create a Plan
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default NoPlans
